import {createSlice} from "@reduxjs/toolkit";
import {fetchComponentInfo} from "./action";


const initialState = {
    items: [],
    loadingStatus: 'loaded',
    lastComponentLoadTime: new Date().getTime(),
}

const componentSlice = createSlice({
    name: 'componentInfo',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchComponentInfo.pending, state => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchComponentInfo.fulfilled, (state, action) => {
                state.lastComponentLoadTime = new Date().getTime();
                state.loadingStatus = 'loaded';
                state.items = action.payload;
            })
            .addCase(fetchComponentInfo.rejected, state => {
                state.loadingStatus = 'error';
            });
    }
});

export const {reducer} = componentSlice;

export default reducer;
